import { InitiativeStatus } from "api";

export const INITIATIVE_STATUS_LABELS: Record<InitiativeStatus, string> = {
    DRAFT: "Draft",
    UNDER_REVIEW: "Under Review",
    APPROVED: "Approved",
    IN_PROGRESS: "In Progress",
    COMPLETED: "Completed",
    CANCELLED: "Cancelled",
    ON_HOLD: "On Hold",
};

export const INITIATIVE_STATUS_BG_COLORS: Record<InitiativeStatus, string> = {
    DRAFT: "#F3F4F6",
    UNDER_REVIEW: "#FEF3C7",
    APPROVED: "#D1FAE5",
    IN_PROGRESS: "#DBEAFE",
    COMPLETED: "#DCFCE7",
    CANCELLED: "#FEE2E2",
    ON_HOLD: "#F3F4F6",
};

export const INITIATIVE_STATUS_TEXT_COLORS: Record<InitiativeStatus, string> = {
    DRAFT: "#6B7280",
    UNDER_REVIEW: "#92400E",
    APPROVED: "#065F46",
    IN_PROGRESS: "#1E40AF",
    COMPLETED: "#166534",
    CANCELLED: "#991B1B",
    ON_HOLD: "#6B7280",
};
